module.exports = __webpack_public_path__ + "static/img/cupon.41a14ab.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/cupon.png
// module id = CM68
// module chunks = 47